import { render, staticRenderFns } from "./AdminDash.vue?vue&type=template&id=2b3e8a1e&scoped=true"
import script from "./AdminDash.vue?vue&type=script&lang=js"
export * from "./AdminDash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3e8a1e",
  null
  
)

export default component.exports